module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0032.jpg?v=b038d9ff";